module.exports = __webpack_public_path__ + "static/media/angola.1d2340f7.svg";